export const ADD_TYPES = 'ADD_TYPES'
export const ADD_TYPE = 'ADD_TYPE'
